import React, { useEffect } from "react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Card, Col, Row, Typography } from "antd";

const { Text } = Typography;

const UpdateAvailableDebitTags = (props) => {
  const { tagName, tags, setTags, allowedDebitTags, setAllowedDebitTags } =
    props;

  // Merge once per change of inputs: ensures previously selected show up even if `tags` was empty/missing some
  useEffect(() => {
    // Build a map of id -> tag, starting with all `tags`
    const map = new Map();
    (Array.isArray(tags) ? tags : []).forEach((t) => {
      map.set(t.id, { ...t });
    });

    // Lay over previously allowed tags; force them assigned=true, available=false
    (Array.isArray(allowedDebitTags) ? allowedDebitTags : []).forEach((t) => {
      const prev = map.get(t.id) || t;
      map.set(t.id, { ...prev, assigned: true, available: false });
    });

    const merged = Array.from(map.values());

    // Detect if anything actually changed to avoid loops
    const changed =
      merged.length !== (tags?.length || 0) ||
      merged.some((m) => {
        const orig = (tags || []).find((t) => t.id === m.id);
        return (
          !orig ||
          orig.assigned !== m.assigned ||
          orig.available !== m.available
        );
      });

    if (changed) {
      setTags(merged);
      setAllowedDebitTags(merged.filter((t) => t.assigned));
    }
  }, [tags, allowedDebitTags, setTags, setAllowedDebitTags]);

  const handleToggle = (id) => {
    const updated = (tags || []).map((t) =>
      t.id === id ? { ...t, assigned: !t.assigned, available: !t.available } : t
    );
    setTags(updated);
    setAllowedDebitTags(updated.filter((t) => t.assigned));
  };

  const availableTags = (tags || []).filter((t) => !t.assigned);
  const selectedTags = (tags || []).filter((t) => t.assigned);

  return (
    <div>
      <Row>
        {/* Available */}
        <Col span={9}>
          <Card
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            title={`Available ${tagName} Tags`}
          >
            {availableTags.map((tag) => (
              <Row key={tag.id} style={{ marginTop: 0, marginBottom: 20 }}>
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    width: "100%",
                    paddingBottom: 20,
                  }}
                >
                  <Text>{tag.name}</Text>
                </div>
              </Row>
            ))}
          </Card>
        </Col>

        {/* Actions */}
        <Col span={4}>
          <Card style={{ borderRadius: 0 }} title="Action">
            {(tags || []).map((tag) => (
              <Row key={tag.id} style={{ marginTop: 0, marginBottom: 20 }}>
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    width: "100%",
                    paddingBottom: 26,
                    marginLeft: "40%",
                    marginRight: "40%",
                    cursor: "pointer",
                  }}
                  onClick={() => handleToggle(tag.id)}
                >
                  {tag.assigned ? (
                    <ArrowLeftOutlined />
                  ) : (
                    <ArrowRightOutlined />
                  )}
                </div>
              </Row>
            ))}
          </Card>
        </Col>

        {/* Selected (previous + new) */}
        <Col span={9}>
          <Card
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            title={`Selected ${tagName} Tags`}
          >
            {selectedTags.map((tag) => (
              <Row key={tag.id} style={{ marginTop: 0, marginBottom: 20 }}>
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    width: "100%",
                    paddingBottom: 20,
                  }}
                >
                  <Text>{tag.name}</Text>
                </div>
              </Row>
            ))}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default UpdateAvailableDebitTags;
